import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import ShowTeamFeedback from "./components/ShowTeamFeedback";

function EmployeePerformance() {
  const [userData, setUserData] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const [showTeamFeedbackModal, setShowTeamFeedbackModal] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);

  useEffect(() => {
    const fetchEmployeesPerformance = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(
          `${API_BASE_URL}/employeeinfos/employee_performance_details/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(res?.data);
        setUserData(res?.data?.employee_performance);
        const departments = [
          ...new Set(
            res.data.employee_performance.map((emp) => emp.department).filter(Boolean)
          ),
        ];
        setDepartmentOptions(departments);
       } catch (err) {
        console.error("Error fetching data:", err);
        setUserData([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchEmployeesPerformance();
  }, []);

  const columns = [
    // {
    //   accessorKey: "id",
    //   header: "Emp_id",
    //   size: 150,
    // },
    {
      accessorKey: "userpic",
      header: "Picture",
      size: 80,
      Cell: ({ row }) => {
        const imageUrl = row.original.userpic
          ? `https://pinepositivemoves.com/files/media/${row.original.userpic}`
          : "https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg";

        return (
          <img
            src={imageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/default-profile.png";
            }}
          />
        );
      },
    },
    // {
    //   accessorKey: "Fullname",
    //   header: "Name",
    //   size: 150,
    //   Cell: ({ row }) => (
    //     <Link to={`/employeeinfo/view/${row.original.id}`}>
    //       {row.original.employee || row.original.username}
    //     </Link>
    //   ),
    // },
    {
      accessorKey: "Fullname",
      header: "Name",
      size: 150,
      Cell: ({ row }) => {
        const handleClick = () => {
          setSelectedEmployeeId(row.original.id);
          setShowTeamFeedbackModal(true);
        };

        return (
          <span
            onClick={handleClick}
            style={{
              cursor: "pointer",
              color: "#0d6efd",
              textDecoration: "underline",
            }}
          >
            {row.original.employee || row.original.username}
          </span>
        );
      },
    },
    {
      accessorKey: "designation",
      header: "Designation",
      size: 130,
    },
    {
      accessorKey: "department",
      header: "Department",
      size: 100,
      filterVariant: "select",
      filterSelectOptions: departmentOptions,
    },

    {
      accessorKey: "self_assessment_done",
      header: "Self Assessment",
      size: 100,
      filterVariant: "select",
      filterSelectOptions: ["Yes", "No"],
    },

    {
      accessorKey: "bu_review_done",
      header: "BU Review",
      size: 100,
      filterVariant: "select",
      filterSelectOptions: ["Yes", "No"],
    },
   {
    accessorKey: "self_assessment_date",
    header: "Assessment Date",
    size: 70,
    Cell: ({ cell }) => {
        const value = cell.getValue();

        if (!value) return "-";

        return new Date(value).toLocaleDateString("en-GB");
    },
    },
    {
    accessorKey: "bu_review_date",
    header: "BU Review Date",
    size: 70,
    Cell: ({ cell }) => {
        const value = cell.getValue();

        if (!value) return "-";

        return new Date(value).toLocaleDateString("en-GB");
    },
    },
  ];

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
          <h5>Employees Performance Review</h5>
        </div>
        {showTeamFeedbackModal && (
            <ShowTeamFeedback
                show={showTeamFeedbackModal}
                employeeId={selectedEmployeeId}
                onClose={() => {
                setShowTeamFeedbackModal(false);
                }}
                year={"2025-2026"}
                token={token}
                onSuccess={async () => {
                setShowTeamFeedbackModal(false);
                }}
            />
            )}
        <div className="card-body">
          {userData.length === 0 ? (
            <p className="text-muted">No employees found.</p>
          ) : (
            <MaterialReactTable
                columns={columns}
                data={userData}
                enableColumnOrdering
                enableFilters
                layoutMode="grid"
                initialState={{
                    pagination: { pageIndex : 0, pageSize: 50 },
                    density: "compact",
                }}
                muiTableBodyCellProps={{
                    sx: {
                    padding: "6px 8px",
                    fontSize: "13px",
                    whiteSpace: "nowrap",
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                    padding: "8px",
                    fontSize: "13px",
                    whiteSpace: "nowrap",
                    },
                }}
                />
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployeePerformance;
